import { Component, ViewEncapsulation, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4501Model } from './kymw4501.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetFixFeatureService } from './api-services/get-fix-feature.service';

/**
 * 固定特集一覧画面を管理するクラス
 *
 * @export KYMW4501Component
 * @class KYMW4501Component
 */
@Component({
  selector: 'app-kymw4501',
  templateUrl: 'kymw4501.component.html',
  styleUrls: ['kymw4501.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4501Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  kymw4501Model: KYMW4501Model = new KYMW4501Model();
  closeFunction: Function;

  @ViewChild('fltr_mediumNameList', {static: true}) fltr_mediumNameList: FlexGridFilter;

  /**
   * Creates an instance of KYMW4501Component.
   * @memberof KYMW4501Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public getFixFeatureService: GetFixFeatureService,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4501';
    // 固定特集一覧取得
    this.getFixFeatureService.execute(this.kymw4501Model);
  }

  public ngAfterViewInit(): void {
    // フィルタ設定
    if (this.fltr_mediumNameList) {
      this.fltr_mediumNameList.defaultFilterType = FilterType.Both;
      this.fltr_mediumNameList.filterColumns = ['mediumName'];
      this.fltr_mediumNameList.showSortButtons = false;
    }
  }
}
